import { useEffect, useMemo, useState } from 'react';
import { useTrimesters } from '../../trimesters/context/TrimestersContext';
import { classroomService } from '../services/classroom.service';

export const useEnsureClassroom = (classroomId?: string | null, trimesterId?: string) => {
  const { classes, setClasses } = useTrimesters();
  const [isLoadingClassroom, setIsLoadingClassroom] = useState(false);
  const [classroomError, setClassroomError] = useState<string | null>(null);

  const classroom = useMemo(
    () => classes.find((item) => String(item.id) === String(classroomId)) ?? null,
    [classroomId, classes]
  );

  useEffect(() => {
    let mounted = true;

    if (!classroomId || classroom) {
      setIsLoadingClassroom(false);
      setClassroomError(null);
      return () => {
        mounted = false;
      };
    }

    setIsLoadingClassroom(true);
    setClassroomError(null);

    classroomService
      .getById(classroomId, trimesterId)
      .then((loadedClassroom) => {
        if (!mounted || !loadedClassroom) return;

        setClasses((current) => {
          const existingIndex = current.findIndex((item) => item.id === loadedClassroom.id);

          if (existingIndex >= 0) {
            return current.map((item, index) => (index === existingIndex ? loadedClassroom : item));
          }

          return [loadedClassroom, ...current];
        });
      })
      .catch((error) => {
        if (!mounted) return;
        setClassroomError(error instanceof Error ? error.message : 'Nao foi possivel carregar a turma.');
      })
      .finally(() => {
        if (!mounted) return;
        setIsLoadingClassroom(false);
      });

    return () => {
      mounted = false;
    };
  }, [classroom, classroomId, setClasses, trimesterId]);

  return {
    classroom,
    isLoadingClassroom,
    classroomError,
  };
};
